// Mirrors the backend's SocietyStatus/SocietyPlan enums exactly (they serialize
// via @JsonValue -> name(), i.e. the Java constant names themselves — uppercase).
// Single source of truth so admin pages don't each redeclare their own (previously
// lowercase, drifted-from-the-wire) copy of these types.
export type SocietyStatus = 'PENDING' | 'ACTIVE' | 'SUSPENDED';
export type SocietyPlan = 'FREE' | 'STARTER' | 'PRO';

export const STATUS_STYLE: Record<SocietyStatus, { color: string; bg: string; label: string }> = {
  PENDING: { color: '#D97706', bg: 'rgba(245,158,11,0.1)', label: 'Pending' },
  ACTIVE: { color: '#059669', bg: 'rgba(16,185,129,0.1)', label: 'Active' },
  SUSPENDED: { color: '#DC2626', bg: 'rgba(239,68,68,0.1)', label: 'Suspended' },
};

export const PLAN_STYLE: Record<SocietyPlan, { color: string; bg: string; label: string }> = {
  FREE: { color: '#64748B', bg: 'rgba(100,116,139,0.1)', label: 'Free' },
  STARTER: { color: '#1A6CF6', bg: 'rgba(26,108,246,0.1)', label: 'Starter' },
  PRO: { color: '#7C3AED', bg: 'rgba(109,40,217,0.1)', label: 'Pro' },
};
